import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
export const SOCIAL_INTERACTION_VIEW_COUNTER = gql `
  query SocialInteractionTargetViewCounter($urn: GlobalID!) {
    viewer {
      socialInteractionTarget(urn: $urn) {
        urn
        viewsCount
        __typename
      }
      __typename
    }
  }
`;
export const useViewCounter = (urn) => {
    var _a;
    const { data } = useQuery(SOCIAL_INTERACTION_VIEW_COUNTER, {
        fetchPolicy: 'no-cache',
        variables: { urn },
    });
    return { ...(((_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.socialInteractionTarget) || { viewsCount: 0 }) };
};
//# sourceMappingURL=view-counter-query.js.map